import { render, staticRenderFns } from "./binFenCustomer-user-list.vue?vue&type=template&id=0484d63f&scoped=true"
import script from "./binFenCustomer-user-list.vue?vue&type=script&lang=js"
export * from "./binFenCustomer-user-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484d63f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0484d63f')) {
      api.createRecord('0484d63f', component.options)
    } else {
      api.reload('0484d63f', component.options)
    }
    module.hot.accept("./binFenCustomer-user-list.vue?vue&type=template&id=0484d63f&scoped=true", function () {
      api.rerender('0484d63f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account-management/binFenCustomer-user-management/binFenCustomer-user-list.vue"
export default component.exports